import React from 'react';
import wallUp from '../media/img/brick-up.jpg';
import wallDown from '../media/img/brick-down.jpg'

const Wall = (props) => {
  return (
    <div style={{zIndex:10, position:"fixed"}} className="w-100 h-100">
      <img className={`w-100 wall wall-${props.status}1`}src={wallUp} alt=""/>
      <img className={`w-100 wall wall-${props.status}2`}src={wallDown} alt=""/>
    </div>
  );
};

export default Wall;